import React from "react"

export const PAYTM_MERCHANT_COLUMNS = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Center",
    accessor: "centerName",
  },
  {
    Header: "Merchant ID",
    accessor: "merchantId",
  },
  {
    Header: "Merchant Key",
    accessor: (d: any) => (d?.merchantKey ? `*****` : ""),
  },
  {
    Header: "Channel ID",
    accessor: "channelId",
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: (props: any) => {
      console.log("props?.value", props)
      return props?.value?.toLowerCase() === "active" ? (
        <span style={{ color: "green" }}>Active</span>
      ) : (
        <span style={{ color: "red" }}> Inactive</span>
      )
    },
  },
  {
    Header: "",
    accessor: "Edit",
    Cell: () => (
      <img
        className="eye-icon"
        src={"assets/images/CRedit.svg"}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="eye"
      />
    ),
  },
]
